import { images } from '../constants';

const discoverOurSpace = [
  images.gallery1,
  images.gallery2,
  images.gallery3,
  images.gallery4,
  images.gallery5,
  images.gallery6,
  images.gallery7,
  images.gallery8,
  images.gallery9,
  images.gallery10,
  images.gallery11,
  images.gallery12,
  images.gallery13,
  images.gallery14,
  images.gallery15,
  images.gallery16,
  images.gallery17,
  images.gallery18,
  images.gallery19,
  images.gallery20,
];

const savorTheFlavors = [
  images.meal1,
  images.meal2,
  images.meal3,
  images.meal4,
  images.meal5,
  images.meal6,
  images.meal7,
  images.meal8,
  images.meal9,
  images.meal10,
  images.meal11,
  images.meal12,
  images.meal13,
  images.meal14,
  images.meal15,
  images.meal16,
  images.meal17,
  images.meal18,
  images.meal19,
  images.meal20,
  images.meal21,
  images.meal22,
  images.meal23,
  images.meal24,
  images.meal25,
  images.meal26,
  images.meal27,
  images.meal28,
  images.meal29,
  images.meal30,
  images.meal31,
  images.meal32,
  images.meal33,
  images.meal34,
  images.meal35,
  images.meal36,
];

// eslint-disable-next-line
export default { savorTheFlavors, discoverOurSpace };
